import React from 'react'

const AddSonIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/add-son.svg" : "/assets/icons/add-son.svg"}
             alt="add son"
             style={props.style}
        />
    )
}

export default AddSonIcon